import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=ba97ecb8&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=ba97ecb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba97ecb8",
  null
  
)

export default component.exports